import React from 'react'
import styles from './ToggleButton.module.scss'
import { ToggleButtonProps } from './ToggleButton.types'
import { IconChecked, IconClose } from 'assets'
import cl from 'classnames'

const ToggleButtonComponent = (props: ToggleButtonProps) => {
  const { label, isSwitchedOn, disabled, onClick, className, style } = props

  const handleClick = () => {
    if (disabled) return
    onClick && onClick()
  }
  return (
    <div
      className={cl(styles.container, {
        [styles.switchedOff]: !isSwitchedOn,
        [styles.clickable]: !disabled,
        [styles.disabled]: disabled
      }, className)}
      style={style}
      onClick={handleClick}
    >
      {label && <label>{label}</label>}
      <div className={styles.toggle}>
        {isSwitchedOn && <IconChecked fill={styles.blue} />}
        <div className={styles.circle} />
        {!isSwitchedOn && <IconClose fill={styles.grey} />}
      </div>
    </div>
  )
}

const ToggleButton = ToggleButtonComponent
export { ToggleButton }
